import styled, { css, keyframes } from 'styled-components';
import cardBg from '../../assets/images/card_bg.png';
import print from '../../assets/images/print.png';

const hideCardKeyframes = keyframes`
	0% {
		transform: translateX(0);
		rotate: 0deg;
    opacity: 1;
	}
	50% {
		transform: translateX(-260px);
		rotate: 0deg;
		opacity: 1;
	}
	100% {
		transform: translateX(0);
		rotate: 15deg;
		opacity: 0.25;
	}
`;

const showCardKeyframes = keyframes`
	0% {
		transform: translateX(0);
		rotate: 15deg;
    opacity: 0.25;
	}
	50% {
		transform: translateX(260px);
		rotate: 0deg;
    opacity: 1;
	} 
	100% {
		transform: translateX(0);
		rotate: 0deg;
    opacity: 1;
	}
`;

const StyledWrapper = styled.div<{
	$isEntering: boolean;
	$isExiting: boolean;
	$isVisible: boolean;
	$isHidden: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 460px;
	height: 600px;
	background: radial-gradient(
			50% 50% at 0% 0%,
			rgba(255, 255, 255, 0.05) 0%,
			rgba(255, 255, 255, 0) 100%
		),
		rgba(255, 255, 255, 0.1);
	border-radius: 20px;

	opacity: ${(props) =>
		props.$isHidden && !props.$isEntering && !props.$isExiting && 0.25};
	visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
	rotate: ${(props) => (props.$isHidden ? '15deg' : '0deg')};
	transform-origin: center;

	${(props) =>
		props.$isEntering &&
		css`
			animation-name: ${showCardKeyframes};
		`}

	${(props) =>
		props.$isExiting &&
		css`
			animation-name: ${hideCardKeyframes};
		`}
	
	animation-duration: 510ms;
	animation-iteration-count: 1;
`;

const StyledContainer = styled.div`
	position: relative;
	width: 420px;
	height: 560px;
	background: url(${cardBg}),
		radial-gradient(100% 100% at 0% 0%, #d4cfe3 0%, #ebd9d9 100%),
		radial-gradient(100% 100% at 0% 0%, #d4cfe3 0%, #ebd9d9 100%);
	border-radius: 10px;
	box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
	overflow: hidden;
`;

const StyledHeadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	margin-top: 27px;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 27px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	width: 100%;
`;

const StyledPrint = styled.div`
	position: absolute;
	top: 155px;
	left: 141px;
	width: 546px;
	height: 546px;
	background-image: url(${print});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export {
	StyledBottomContainer,
	StyledContainer,
	StyledHeadingContainer,
	StyledPrint,
	StyledWrapper,
};
